<template>
    <div v-if="!loading">
        <v-card class="mt-8 mx-8 pa-4">
            <v-card-title>نمایش کاور ها</v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" sm="12" md="3" lg="3">
                        <v-select color="black" v-model="order" label="نوع کاور ها را انتخاب کنید" :items="orderItems"
                                  item-text="name" @change="getCovers"></v-select>
                    </v-col>
                    <v-col cols="12" sm="12" md="9" lg="9" class="text-left">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon x-large class="hover-link mx-1"
                                        color="success"
                                        v-bind="attrs"
                                        v-on="on" @click="$router.push('/cover/create')">mdi-plus
                                </v-icon>
                            </template>
                            <span class="tooltip-text">ساخت کاور جدید</span>
                        </v-tooltip>
                    </v-col>
                    <v-col cols="12">
                        <v-data-table
                                align="center"
                                item-key="id"
                                :headers="headers"
                                :items="covers.data"
                                :items-per-page="10"
                                disable-sort
                                expand-icon="mdi-chevron-up"
                                hide-default-footer>
                            <template
                                    v-slot:[`item.operation`]="{ item }">
                                <v-icon class="mx-1" color="error" @click="destroy(item.id)">mdi-trash-can-outline
                                </v-icon>
                            </template>
                            <template
                                    v-slot:[`item.url`]="{ item }">
                                <img :src="item.url" height="150" width="150" :alt="item.tag">
                            </template>
                        </v-data-table>
                    </v-col>
                    <v-col cols="12">
                        <v-pagination
                                class="text-center"
                                color="#696CFF"
                                v-model="covers.current_page"
                                :length="covers.last_page"
                                circle
                                @input="getCovers"
                        ></v-pagination>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
export default {
    name: "CoverIndexView",
    data() {
        return {
            loading: true,
            orderItems: [
                {name: 'دوره ها', value: 'course'},
                {name: 'درس ها', value: 'item'},
                {name: 'فایل ها', value: 'item_file'},
            ],
            order: 'item_file',
            covers: {
                current_page: 1
            },
            headers: [
                {text: 'شناسه', value: 'id', align: 'center', width: '2%'},
                {text: 'نوع', value: 'type', align: 'center', width: '10%'},
                {text: 'تگ', value: 'tag', align: 'center', width: '10%'},
                {text: 'کاور', value: 'url', align: 'center', width: '10%'},
                {text: 'عملیات', value: 'operation', align: 'center', width: '15%'},
            ],
        }
    },
    mounted() {
        this.getCovers()
    },
    methods: {
        getCovers() {
            let url = '/file-manager/cover/index?page=' + this.covers.current_page ?? 1
            url = url + '&type=' + this.order
            window.axios.get(url).then((res) => {
                this.covers = res.data.data
                this.loading = false
            }).catch((err) => {
                this.openSnackbar(err.response.data.message, '#F1416C')
            })
        },
        destroy(coverId) {
            window.axios.delete('file-manager/cover/delete/' + coverId).then(() => {
                this.getCovers()
            }).catch((err) => {
                this.openSnackbar(err.response.data.message, '#F1416C')
            })
        }
    }
}
</script>

<style scoped>

</style>